import {AfterViewInit, ChangeDetectorRef, Component, QueryList, ViewChildren} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {GenericCommandInputComponent} from '../../../../shared/generic-command-input/generic-command-input.component';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ExecuteCommandArgs} from '../../../../../model/synoptics/synoptic-arg-types';

@Component({
  selector: 'app-synoptic-visualization-command-params',
  templateUrl: './synoptic-visualization-command-params.component.html',
  styleUrls: ['./synoptic-visualization-command-params.component.scss']
})
export class SynopticVisualizationCommandParamsComponent implements AfterViewInit {
  @ViewChildren(GenericCommandInputComponent) viewCommandInputs!: QueryList<GenericCommandInputComponent>;

  params: { [key: string]: any };
  paramValues: { [key: string]: any };
  args: ExecuteCommandArgs;

  industrialFormValidity: boolean;
  isFormValid$: Observable<boolean>;

  ngAfterViewInit(): void {
    if (this.viewCommandInputs.length > 0) {
      const inputValidations$: Observable<boolean>[] = this.viewCommandInputs.map((input: GenericCommandInputComponent) => input.isValid$);
      this.isFormValid$ = combineLatest(inputValidations$).pipe(
        map((validations: boolean[]) => validations.every((isValid: boolean) => isValid))
      );
    } else {
      this.isFormValid$ = new BehaviorSubject(true);
    }
    this.cdr.detectChanges();
  }

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, public cdr: ChangeDetectorRef) {
    this.params = config.data.paramsFromSchema;

    this.args = config.data.args;

    if (!this.args.params) {
      this.paramValues = {...config.data.values};
    } else {
      for (let key of Object.keys(this.params)) {
        if (!this.args.params.hasOwnProperty(key)) {
          this.args.params[key] = null;
        }
      }
      this.paramValues = {...this.args.params};
    }
  }

  updateModel(valueKey: string, event: any): void {
    this.paramValues[valueKey] = event;
    this.checkChanges();
  }

  checkChanges(): void {
    this.paramValues = {...this.paramValues};
    this.cdr.detectChanges();
  }

}
